import AdminPaymentGatewaySettingsPage from '../../../components/admin/settings/AdminPaymentGatewaySettingsPage'

export default function SettingsPayment() {
  return <AdminPaymentGatewaySettingsPage />
}
